import {
    QueryFunction,
    QueryKey,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';

import { EventsApiService } from '../api/events-api.service';
import { fieldsBookingsQueryKeys } from './price-query-keys';
const { getEventOutlet } = EventsApiService();

const getOrganizerQuery = (
    params: any,
    options?: UseQueryOptions<any>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<any>;
    options?: UseQueryOptions<any>;
} => ({
    queryKey: fieldsBookingsQueryKeys.list(params),
    queryFn: ({ signal }) => getEventOutlet(params, { config: { signal } }),
    ...options,
});

export const useGetOutlet = (
    params: any,
    options?: UseQueryOptions<any>,
) => {
    const { message } = App.useApp();

    return useQuery<any, Error>(
        getOrganizerQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};



